var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6799_34304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2006 16.0704C21.2115 18.5559 19.3512 20.5954 16.968 21.8071C14.5848 23.0188 11.8421 23.3197 9.25322 22.6534C6.66437 21.9871 4.40689 20.3992 2.90336 18.1872C1.39984 15.9751 0.753341 13.2904 1.0849 10.6356C1.41645 7.98085 2.70332 5.53803 4.70462 3.76443C6.70592 1.99083 9.28445 1.00805 11.9575 1.00005C14.6306 0.99205 17.2149 1.95938 19.2268 3.72097C21.2386 5.48256 22.5401 7.91763 22.8875 10.5704L23 12.3642M22.8875 20.1963V16.0704L18.8352 16.0713",
    stroke: "#505050",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6C8.688 6 6 8.688 6 12C6 15.312 8.688 18 12 18C15.312 18 18 15.312 18 12C18 8.688 15.312 6 12 6ZM7.2 12C7.2 11.634 7.248 11.274 7.326 10.932L10.194 13.8V14.4C10.194 15.06 10.734 15.6 11.394 15.6V16.758C9.036 16.458 7.2 14.442 7.2 12ZM15.534 15.24C15.378 14.754 14.934 14.4 14.394 14.4H13.794V12.6C13.794 12.27 13.524 12 13.194 12H9.594V10.8H10.794C11.124 10.8 11.394 10.53 11.394 10.2V9H12.594C13.254 9 13.794 8.46 13.794 7.8V7.554C15.552 8.262 16.8 9.99 16.8 12C16.8 13.248 16.314 14.388 15.534 15.24Z",
    fill: "#505050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6799_34304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconRotate);
export default __webpack_public_path__ + "static/media/tabler-icon-rotate.1fe1920cd06d29b6c5c75900bac331ac.svg";
export { ForwardRef as ReactComponent };